export class RouteConstant {
  static readonly root = '';
  static readonly home = '';
  static readonly index = 'index.html';
  static readonly document = 'document';
  static readonly confirmation = 'confirmation';
  static readonly fromConnective = 'fromconnective';
  static readonly error = 'error';
  static readonly nextsteps = 'nextsteps';
}

export class ParameterConstant {
  static readonly SignatureRequestId = '/:signatureRequestId';
  static readonly ParticipantId = '/:participantId';
  static readonly SignatureStatus = '/:status';
}
